<template>
  <section>
    <div
      v-if="active"
      class="loading"
    >
      <div class="wrap-icon">
        <i class="fas fa-spinner" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      active: false,
    };
  },
  methods: {
    open() {
      this.active = true;
    },
    close() {
      this.active = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  z-index: 10000000;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
.wrap-icon {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fa-spinner {
  font-size: 60px;
  color: #ffce06;
  animation-name: spin;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
